import React from 'react';
import Button from 'components/controls/Button/Button';
import './CallToAction.css';

interface CallToActionProps {
	title: string;
	subtitle?: string;
	buttonText: string;
	to?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
	title,
	subtitle,
	buttonText,
	to = '/contact',
}) => {
	return (
		<section className="cta-banner">
			{/* Decorative blobs */}
			<div className="cta-banner__blob cta-banner__blob--1" />
			<div className="cta-banner__blob cta-banner__blob--2" />
			<div className="cta-banner__blob cta-banner__blob--3" />

			<div className="cta-banner__content">
				<h2 className="cta-banner__title">{title}</h2>
				{subtitle && <p className="cta-banner__subtitle">{subtitle}</p>}
				<Button to={to} variant="primary" size="lg">
					{buttonText}
				</Button>
			</div>
		</section>
	);
};

export default CallToAction;
